import styled from 'styled-components';

const WrapImageCropper = styled.div``;

const WrapRotateButton = styled.div`
  position: relative;
  padding: 0px 23px;
  line-height: 1;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.25);
  .anticon:last-child {
    margin-left: 5px;
  }
`;
const WrapImageCtlBtn = styled.div`
  margin: 0 auto;
  width: 280px;
  button {
    margin-left: 3px;
    margin-top: 10px;
  }
  button:first-child {
    margin-left: 0px;
  }
`;

const WrapActionBtn = styled.div`
  margin: 0 auto;
  width: 170px;
  button {
    margin-left: 3px;
    margin-top: 10px;
  }
  button:first-child {
    margin-left: 0px;
  }
`;

export { WrapImageCropper, WrapRotateButton, WrapImageCtlBtn, WrapActionBtn };



// WEBPACK FOOTER //
// ./src/components/imageCropper/index.styled.ts